<template>
  <v-app-bar
    app
    clipped-left
    :color="theme"
    dark
  >
    <v-app-bar-nav-icon @click.stop="openDrawer"></v-app-bar-nav-icon>
    <v-toolbar-title @click="goToIndexPage">{{ head }}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn
      icon
      :to="{ name: 'profile' }"
    >
      <v-icon>mdi-account</v-icon>
    </v-btn>
    <v-btn
      text
      @click="logout"
    >
      Logout
    </v-btn>
  </v-app-bar>
</template>

<script>
import { clearStorage } from '../../_helpers';
  export default {
    name: 'AppBar',
    methods: {
      goToIndexPage () {
        this.$router.push({ path: '/' });
      },
      openDrawer () {
        this.drawer = !this.drawer
        this.$emit('toggleDrawer', this.drawer)
      },
      logout () {
        clearStorage('_admin')
        this.$router.push({ name: 'login' })
      }
    },
    data: () => ({
      drawer: true,
      theme: 'orange darken-3',
      biz: ['cleaning-supplies', 'suppliers'],
      head: 'Ayasan'
    }),
  }
</script>

<style>
  .app-logo:hover .v-image,
  .v-toolbar__title {
    cursor: pointer;
  }
</style>
